var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricboardCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.30908,
    y: 7.93359,
    width: 13.5333,
    height: 12.1333,
    rx: 0.933333,
    fill: "#46474C",
    stroke: "#46474C",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5175 13.8832L23.2755 10.9677L23.2755 16.7988L19.5175 13.8832Z",
    fill: "#46474C",
    stroke: "#46474C",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83608 22.5129C3.52374 22.8252 3.64781 23.2989 3.90799 23.5591C4.16816 23.8192 4.64185 23.9433 4.95419 23.631L22.0358 6.54934C22.3481 6.237 22.2241 5.76331 21.9639 5.50314C21.7037 5.24297 21.23 5.11889 20.9177 5.43123L3.83608 22.5129Z",
    fill: "#46474C",
    stroke: "#F7F7F8",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricboardCamera);
export default __webpack_public_path__ + "static/media/electricboard-camera.6dd07989e94af5f62e387fa82ff47272.svg";
export { ForwardRef as ReactComponent };